export default {
    autoBind: {
        type: Boolean,
        default: undefined
    }, 
    columns: {
        type: Array,
        default: undefined
    }, 
    resizable: {
        type: Boolean,
        default: undefined
    }, 
    reorderable: {
        type: Boolean,
        default: undefined
    }, 
    columnMenu: {
        type: [Boolean, Object],
        default: undefined
    }, 
    dataSource: {
        type: [Object, Array],
        default: undefined
    }, 
    editable: {
        type: [Boolean, Object],
        default: undefined
    }, 
    excel: {
        type: Object,
        default: undefined
    }, 
    filterable: {
        type: [Boolean, Object],
        default: undefined
    }, 
    height: {
        type: [Number, String],
        default: undefined
    }, 
    messages: {
        type: Object,
        default: undefined
    }, 
    navigatable: {
        type: Boolean,
        default: undefined
    }, 
    pageable: {
        type: [Boolean, Object],
        default: undefined
    },
    pdf: {
        type: Object,
        default: undefined
    }, 
    scrollable: {
        type: [Boolean, Object],
        default: undefined
    }, 
    selectable: {
        type: [Boolean, String],
        default: undefined
    }, 
    sortable: {
        type: [Boolean, Object],
        default: undefined
    }, 
    toolbar: {
        type: [String, Function, Array],
        default: undefined
    }, 

    // Events
    beforeEdit: {
        type: Function,
        default: undefined
    }, 
    cancel: {
        type: Function,
        default: undefined
    },  
    cellClose: {
        type: Function,
        default: undefined
    }, 
    change: {
        type: Function,
        default: undefined
    },  
    collapse: {
        type: Function,
        default: undefined
    },  
    dataBinding: {
        type: Function,
        default: undefined
    },  
    dataBound: {
        type: Function,
        default: undefined
    },  
    dragstart: {
        type: Function,
        default: undefined
    },  
    drag: {
        type: Function,
        default: undefined
    },  
    dragend: {
        type: Function,
        default: undefined
    },  
    drop: {
        type: Function,
        default: undefined
    },  
    edit: {
        type: Function,
        default: undefined
    },  
    excelExport: {
        type: Function,
        default: undefined
    },  
    expand: {
        type: Function,
        default: undefined
    },  
    filterMenuInit: {
        type: Function,
        default: undefined
    },  
    pdfExport: {
        type: Function,
        default: undefined
    },  
    remove: {
        type: Function,
        default: undefined
    },  
    save: {
        type: Function,
        default: undefined
    },  
    columnShow: {
        type: Function,
        default: undefined
    },  
    columnHide: {
        type: Function,
        default: undefined
    },  
    columnReorder: {
        type: Function,
        default: undefined
    },  
    columnResize: {
        type: Function,
        default: undefined
    },  
    columnMenuInit: {
        type: Function,
        default: undefined
    },  
    columnLock: {
        type: Function,
        default: undefined
    },  
    columnUnlock: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-treelist-vue-wrapper/src/KendoTreeList/TreeListProps.js